<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{ 'main.nav.links.parameters.simulationFiles.shortLabel' | translate }}
                <app-tooltip [text]="'main.nav.links.parameters.simulationFiles.summary' | translate"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="accent"></mat-progress-bar>
        <section>
            <app-config-files-list *ngIf="importedFiles && importedFiles.length"
                [files]="importedFiles"
                [title]="'parameters.importedList.shortLabel' | translate"
                [selectedFileIds]="config.selectedFileIds"
                (selectedFileChanged)="onSelectFile($event)">
            </app-config-files-list>
        </section>
        <!-- <section>
            <app-config-files-list *ngIf="providerFiles && providerFiles.length"
                [files]="providerFiles"
                [title]="'parameters.providerList.shortLabel' | translate"
                [selectedFileIds]="config.selectedFileIds"
                (selectedFileChanged)="onSelectFile($event)">
            </app-config-files-list>
        </section> -->
    </mat-card-content>
    <mat-card-actions>
        <a mat-raised-button color="accent" [routerLink]="backLink.route">
            <mat-icon aria-label="Back">{{ backLink.icon }}</mat-icon>
            {{ backLink.title | translate }}
        </a>
    </mat-card-actions>
</mat-card>
